import { getDownloadURL, ref } from 'firebase/storage'

import { getFirebaseStorage } from './app'

const downloadUrlCache = new Map<string, Promise<string>>()

/** Resolves (and caches) a public download URL for a Firebase Storage path. */
export function resolveStorageDownloadUrl(storagePath: string): Promise<string> {
  const cached = downloadUrlCache.get(storagePath)
  if (cached) return cached

  const promise = getDownloadURL(ref(getFirebaseStorage(), storagePath))
  downloadUrlCache.set(storagePath, promise)
  promise.catch(() => downloadUrlCache.delete(storagePath))
  return promise
}

/** Drops a cached download URL so the next {@link resolveStorageDownloadUrl} re-fetches it. */
export function invalidateStorageDownloadUrl(storagePath: string): void {
  downloadUrlCache.delete(storagePath)
}

/** Downloads a Firebase Storage object's bytes, as the browser hands them over after any transfer decoding. */
export async function downloadStorageBytes(storagePath: string): Promise<Uint8Array> {
  const url = await resolveStorageDownloadUrl(storagePath)
  const response = await fetch(url)
  if (!response.ok) {
    throw new Error(`Storage download failed with status ${response.status}`)
  }
  return new Uint8Array(await response.arrayBuffer())
}
